module.exports = __webpack_public_path__ + "img/choctaw.1cf62c38.png";